import { Directive, ElementRef, Renderer2, SimpleChanges, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

import { Observable } from 'rxjs';

import { BaseSelectInputDirective } from '../common';
import { CommonDataService } from '../services';
import { ICommonValue } from '../models';

@Directive({
  //  tslint:disable-next-line:directive-selector
  selector: 'select[renci-url]',
})
export class SelectUrlInputDirective extends BaseSelectInputDirective {

  //  tslint:disable-next-line:no-input-rename
  @Input('renci-url') url: string;

  constructor(
    private commonDataService: CommonDataService,
    @Optional() @Self() formControl: NgControl,
    elem: ElementRef,
    renderer: Renderer2) {
    super(formControl, elem, renderer);
    this.refreshNeeded = (changes: SimpleChanges) => true;
  }

  getData(_: any): Observable<ICommonValue[]> {
    return this.commonDataService.getUrlData(this.url);
  }
}
